import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'td-wb-confirm-title',
  template: '<ng-content />',
  styleUrls: ['confirm-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ConfirmTitleComponent {}
